import './App.css';
import Home from './module/Home'

function App() {
  return (
    <Home />
  );
}

export default App;
